import { Injectable, Inject, Injector } from "@angular/core";
import { progress } from "@progress/jsdo-core";
import { NotificationService } from "../notification/notification.service";
import { Notification } from "../notification/notification";

@Injectable()
export class CustomAuthorizationService {
    public showGroupBooking: boolean = false;
    public showBookings: boolean = false;
    public showHistoricalBookings = false;
    public showExchangePoint = false;
    public showContactInfo: boolean = false;
    public showServiceLine: boolean = false;
    public showServices: boolean = false;
    public showShuttleService: boolean = false;
    public showGuidedTours: boolean = false;
    public isExternalBookRefMandatory: boolean = false;
    public displayUnitReference: boolean = false;
    public allowOnRequestDecision: boolean = false;
    public uploadDocuments: string = "Forbidden";
    public groupBookingGrouping;
    public notified = false;
    public groupBookingsGroupInfoPeriod;
    public groupServicesGroupInfoPeriod;

    protected dataLastRead: Date;

    private userSettings: any;

    constructor(
        @Inject(Injector) injector: Injector,
        @Inject(NotificationService)
        protected $notificationService: NotificationService
    ) {}

    public resetDateLastRead() {
        this.dataLastRead = null;
    }

    public cleanAuthorizationData() {
        this.showGroupBooking = false;
        this.showBookings = false;
        this.showHistoricalBookings = false;
        this.showExchangePoint = false;
        this.showContactInfo = false;
        this.showServiceLine = false;
        this.showServices = false;
        this.showShuttleService = false;
        this.showGuidedTours = false;
        this.isExternalBookRefMandatory = false;
        this.displayUnitReference = false;
        this.allowOnRequestDecision = false;
        this.uploadDocuments = "Forbidden";
        this.dataLastRead = null;
        this.notified = false;
    }

    public getPageSettings(PortalModule: string) {
        return this.userSettings.filter(function (item) {
            return item.PortalModule == PortalModule;
        });
    }

    public checkAuthMethod(
        PortalModule: string,
        AuthMethod: string,
        AuthAction: string
    ): any {
        return this.userSettings.filter(function (item) {
            return (
                item.PortalModule == PortalModule &&
                item.AuthorizationMethod == AuthMethod &&
                item.AuthorizationAction == AuthAction
            );
        });
    }

    public async processAuthorizationResponse() {
        if (
            this.dataLastRead &&
            new Date().valueOf() - this.dataLastRead.valueOf() < 60000
        ) {
            return;
        }

        const jsdo = new progress.data.JSDO("AuthorizationProvider");
        await jsdo.read({});
        if (jsdo["ttPusa"]) {
            let ttPusaData = jsdo["ttPusa"].getData();
            this.userSettings = ttPusaData;
            ttPusaData.forEach((ttPusa) => {
                switch (ttPusa.AuthorizationMethod) {
                    case "ExternalBookRefMandatory": {
                        this.isExternalBookRefMandatory =
                            ttPusa.AuthorizationAction === "Mandatory";
                        break;
                    }

                    case "UnitReference": {
                        this.displayUnitReference =
                            ttPusa.AuthorizationAction === "Display";
                        break;
                    }

                    case "UploadDocuments": {
                        this.uploadDocuments = ttPusa.AuthorizationAction;
                        break;
                    }

                    case "GroupBookingGrouping": {
                        this.groupBookingGrouping = ttPusa.AuthorizationAction;
                        break;
                    }
                    case "GroupInfoPeriod": {
                        if (ttPusa.PortalModule === "GroupServices") {
                            this.groupServicesGroupInfoPeriod =
                                ttPusa.AuthorizationAction;
                        }
                        if (ttPusa.PortalModule === "GroupBookings") {
                            this.groupBookingsGroupInfoPeriod =
                                ttPusa.AuthorizationAction;
                        }
                        break;
                    }
                    case "AllowOnRequestDecision": {
                        this.allowOnRequestDecision =
                            ttPusa.AuthorizationAction === "Display";
                        break;
                    }
                }
            });
        }
        if (jsdo["ttPusm"]) {
            let ttPusmData = jsdo["ttPusm"].getData();
            ttPusmData.forEach((ttPusm) => {
                switch (ttPusm.PortalModule) {
                    case "GroupBookings": {
                        this.showGroupBooking = true;
                        break;
                    }
                    case "Bookings": {
                        this.showBookings = true;
                        break;
                    }
                    case "HistoricalBookings": {
                        this.showHistoricalBookings = true;
                        break;
                    }
                    case "ExchangePoint": {
                        this.showExchangePoint = true;
                        break;
                    }
                    case "Contactinfo": {
                        this.showContactInfo = true;
                        break;
                    }
                    case "Transports": {
                        this.showServiceLine = true;
                        break;
                    }
                    case "GroupServices": {
                        this.showServices = true;
                        break;
                    }
                    case "ShuttleService": {
                        this.showShuttleService = true;
                        break;
                    }
                    case "GuidedTours": {
                        this.showGuidedTours = true;
                        break;
                    }
                }
            });
        }

        if (
            !this.notified &&
            !this.showBookings &&
            !this.showHistoricalBookings &&
            !this.showExchangePoint &&
            !this.showContactInfo &&
            !this.showGroupBooking &&
            !this.showGuidedTours &&
            !this.showServiceLine &&
            !this.showServices &&
            !this.showShuttleService
        ) {
            this.$notificationService.notify(
                new Notification(
                    "You don't have access to any module. Please contact your system administrator.",
                    "error",
                    10000
                )
            );
            this.notified = true;
        }

        this.dataLastRead = new Date();
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/core/auth/custom-authorization.service.ts